import { PublicClientApplication } from "@azure/msal-browser";

export const TENANT_ID = "745bfd75-b3d3-4a63-8b64-29ef1d451e71";
export const CLIENT_ID = "0dc1e7fe-5862-479e-b194-ba6f3ae013da";

export const msalInstance = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: typeof window !== "undefined" ? window.location.origin : "/",
    postLogoutRedirectUri:
      typeof window !== "undefined" ? window.location.origin : "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
});

export const loginRequest = {
  scopes: ["User.Read"],
};

export async function getIdToken() {
  const account = msalInstance.getActiveAccount();
  if (!account) return null;
  try {
    const result = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return result.idToken;
  } catch {
    return null;
  }
}
